// extracted by mini-css-extract-plugin
export var avatarContainer = "_5g-1";
export var largeAvatarContainer = "_5g-2";
export var smallAvatarContainer = "_5g-0";